<ion-card
  value="order-history"
  class="border-r10 grey-border no-shadow bg-white ion-margin"
>
  <div class="order" value="open" color="primary">
    <ion-item
      class="ion-no-padding ion-no-margin ion-margin-start mart6 marb6"
      slot="header"
    >
      <ion-thumbnail slot="start">
        <img
          [alt]="displayTitle"
          [src]="displayImage || imagePlaceholder"
          (error)="$any($event.target).src = imagePlaceholder"
        />
      </ion-thumbnail>
      <ion-label class="padr10">
        <h3 class="fs-2 font600 card-primary-text-color">{{ displayTitle }}</h3>
        <p class="fs-1 font500 card-secondary-text-color mar0">
          {{ displayDate }}
          <span *ngIf="bookingitem?.endDate && !bookingitem?.visitDate">
            - {{ bookingitem?.endDate }}
          </span>
        </p>
      </ion-label>
      <ion-chip
        class="ion-no-margin ion-no-padding ion-justify-content-center"
        *ngIf="displayStatus"
        [ngClass]="getStatusClass(displayStatus)"
      >
        <ion-text
          class="fs-1 font500"
          >{{ displayStatus }}</ion-text
        >
      </ion-chip>
      <ion-icon
        name="chevron-forward-outline"
        class="padl10 arrow-icon primary-icon-color"
      ></ion-icon>
    </ion-item>
  </div>
</ion-card>
